module.exports = __webpack_public_path__ + "static/media/8xl2.1244c0e1.png";